import { render, staticRenderFns } from "./SelectorComponent.vue?vue&type=template&id=a8a36d06&scoped=true"
import script from "./SelectorComponent.js?vue&type=script&lang=js&external"
export * from "./SelectorComponent.js?vue&type=script&lang=js&external"
import style0 from "./SelectorComponent.vue?vue&type=style&index=0&id=a8a36d06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a36d06",
  null
  
)

export default component.exports